import React from 'react';
import classNames from 'classnames';
import { useLocaleStore } from '@/i18n/localeStore';

import styles from './index.module.css';

interface IProps {
  text?: string;
}
const Loading: React.FC<IProps> = (props) => {
  const { text } = props;
  const { $t } = useLocaleStore();
  return (
    <div className={classNames(styles.module, styles.loading)}>
      <div className={styles.content}>
        <div className={styles.loadingIcon}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className={styles.text}>{text ?? $t((v) => v.Tips_Loading)}</div>
      </div>
    </div>
  );
};

export default React.memo(Loading);
